import { styled } from '@sans-souci/styles'
import { Container } from '@sans-souci/components'

export const StyledAccountPageRoot = styled(Container, {
  '@lg': {
    maxWidth: '$maxWidthS',
    margin: '0 auto',
  },
})
